<template>
  <div class="detailBox">
    <!-- 基础信息 - 页面头部独立展示 -->
    <div class="baseInfoSection">
      <div class="baseInfoHeader">
        <h3 class="sectionTitle">组合产品基础信息</h3>
        <el-button
          type="primary"
          @click="onSaveBase()"
          :loading="state.saving"
          :icon="Check"
        >
          保存基础信息
        </el-button>
      </div>
      <el-form
        :model="state.model"
        label-width="100px"
        :scroll-to-error="true"
        ref="formDom"
        inline
        class="baseInfoForm"
      >
        <div class="formGrid">
          <el-form-item
            label="状态"
            prop="IsQy"
            :rules="[
              { required: true, message: '请选择状态', trigger: 'blur' },
            ]"
          >
            <el-switch
              v-model="state.model.IsQy"
              inline-prompt
              active-text="上架"
              inactive-text="下架"
            />
          </el-form-item>

          <el-form-item
            label="组合名称"
            prop="Mc"
            :rules="[
              { required: true, message: '请输入组合名称', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="state.model.Mc"
              placeholder="例如：住享食精品套餐"
            />
          </el-form-item>

          <el-form-item label="供应商" prop="GysId">
            <el-select
              v-model="state.model.GysId"
              placeholder="--请选择供应商--"
              :disabled="!Array.isArray(state.gysData)"
            >
              <el-option
                v-for="item in state.gysData || []"
                :key="item.Id"
                :label="item.Mc"
                :value="item.Id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="简介" class="formItemFull">
            <el-input
              type="textarea"
              v-model="state.model.Jj"
              :autosize="{ minRows: 2 }"
              placeholder="组合产品的简要描述"
            />
          </el-form-item>

          <el-form-item label="订单有效期类型" prop="DdyxLx" label-width="110px">
            <el-radio-group v-model="state.model.DdyxLx">
              <el-radio :label="0">固定有效期</el-radio>
              <el-radio :label="1">顺延有效期</el-radio>
            </el-radio-group>
          </el-form-item>

          <template v-if="state.model.DdyxLx === 0">
            <el-form-item label="有效期开始" prop="YxqKs">
              <el-date-picker
                v-model="state.model.YxqKs"
                type="date"
                placeholder="请选择开始日期"
                value-format="YYYY-MM-DDTHH:mm:ss"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item label="有效期结束" prop="YxqJs">
              <el-date-picker
                v-model="state.model.YxqJs"
                type="date"
                placeholder="请选择结束日期"
                value-format="YYYY-MM-DDTHH:mm:ss"
                style="width: 100%"
              />
            </el-form-item>
          </template>

          <template v-if="state.model.DdyxLx === 1">
            <el-form-item label="顺延有效期" prop="YxqJs">
              <div style="display: flex; align-items: center; gap: 8px;">
                <span style="white-space: nowrap; color: #606266;">下单日期至</span>
                <el-input-number
                  v-model="state.model.YxqMonths"
                  :min="1"
                  :max="24"
                  controls-position="right"
                  style="width: 120px"
                />
                <span style="white-space: nowrap; color: #606266;">个月后有效</span>
              </div>
            </el-form-item>
          </template>

          <div class="formItemGroup">
            <el-form-item label="是否预约" prop="IsYuyue" class="formItemYuyue">
              <el-switch
                v-model="state.model.IsYuyue"
                inline-prompt
                active-text="需要"
                inactive-text="不需要"
              />
            </el-form-item>
            <el-form-item
              v-if="state.model.IsYuyue"
              label="提前天数"
              prop="YuyueTianShu"
              class="formItemYuyueTianShu"
            >
              <el-input-number
                v-model="state.model.YuyueTianShu"
                :min="1"
                controls-position="right"
                placeholder="请指定天数"
              />
            </el-form-item>
          </div>

          <el-form-item label="核销码类型" prop="HeXiaoMaLeiXing">
            <el-select v-model="state.model.HeXiaoMaLeiXing" placeholder="请选择">
              <el-option label="无" :value="0" />
              <el-option label="系统自动码" :value="1" />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!-- Tab 区域 -->
    <div class="tabSection">
      <el-tabs v-model="state.activeTab" :before-leave="onTabsChange">
        <el-tab-pane lazy label="住享食详情" name="zxs">

          <!-- ===== 住享食详情（套餐列表） ===== -->
          <div class="zxs-block">
            <div class="zxs-block-header">
              <el-button type="primary" size="small" plain icon="Plus" @click="addPackage">添加详情</el-button>
            </div>

            <draggable
              v-model="state.zxsData.packages"
              item-key="sort"
              handle=".pkg-drag-handle"
              animation="200"
              class="package-list"
            >
              <template #item="{ element, index }">
                <div class="package-card-v2">
                  <!-- 套餐标题栏（橙色左边框风格） -->
                  <div class="pkgv2-header">
                    <span class="pkgv2-label">详情{{ index + 1 }}</span>
                    <el-select v-model="element.category" placeholder="类别" style="width: 90px">
                      <el-option label="食" value="食" />
                      <el-option label="享" value="享" />
                      <el-option label="住" value="住" />
                    </el-select>
                    <el-input v-model="element.name" placeholder="如：自助薄荷糖和爱心小零食 1份" style="flex: 1; max-width: 320px" />
                    <el-button :icon="Edit" link type="primary" size="small" @click="togglePkgExpand(index)">
                      {{ element._expanded ? '收起' : '展开编辑' }}
                    </el-button>
                    <el-button link type="danger" size="small" @click="removePackage(index)">删除</el-button>
                  </div>

                  <!-- 展开编辑区 -->
                  <div v-show="element._expanded !== false" class="pkgv2-body">

                    <!-- 关联供应商（所有类别通用） -->
                    <div class="pkgv2-section">
                      <label>关联供应商</label>
                      <div style="display: flex; align-items: center; gap: 12px;">
                        <el-select
                          v-model="element.gysId"
                          filterable
                          clearable
                          placeholder="请选择供应商"
                          style="width: 80%"
                        >
                          <el-option
                            v-for="item in state.gysData || []"
                            :key="item.Id"
                            :label="item.Mc"
                            :value="item.Id"
                          />
                        </el-select>
                        <div v-show="element.category === '住'" style="display: flex; align-items: center; gap: 4px; white-space: nowrap;">
                          <el-input-number
                            v-model="element.nights"
                            :min="1"
                            :max="30"
                            :controls="true"
                            style="width: 110px"
                          />
                          <span style="font-size: 12px; color: #666">晚</span>
                        </div>
                      </div>
                    </div>

                    <div class="pkgv2-section">
                      <label>结算价</label>
                      <div style="display: flex; align-items: center; gap: 8px;">
                        <span style="font-size: 14px; color: #666;">¥</span>
                        <el-input-number
                          v-model="element.jsj"
                          :min="0"
                          :precision="2"
                          :controls="true"
                          placeholder="与供应商结算的单价"
                          style="width: 200px"
                        />
                        <span style="font-size: 12px; color: #909399;">元/项（用于与供应商对账）</span>
                      </div>
                    </div>

                    <!-- 详情说明（富文本编辑器） -->
                    <div class="pkgv2-section" style="display: block;">
                      <label>详情说明</label>
                      <div style="padding: 8px 0;">
                        <c_editor v-model:value="element.ruleDesc" :key="'ruleDesc_' + index + '_v' + editorVersion" placeholder="适用人数、预约规则、联系电话、规则说明等..." />
                      </div>
                    </div>

                  </div>
                </div>
              </template>
            </draggable>

            <div v-if="!state.zxsData.packages.length" class="empty-tip" style="margin-top: 10px">
              暂无套餐，点击上方按钮添加
            </div>
          </div>


          <!-- ===== 4. 礼品配置（产品级，与套餐列表同级） ===== -->
          <div class="zxs-block">
            <div class="zxs-block-header">
              <span class="zxs-block-title">🎁 礼品配置</span>
              <span class="zxs-block-tip">客户购买此组合产品时可领取的礼品（可跨供应商互斥控制）</span>
              <el-button type="primary" size="small" plain icon="Plus" @click="addGift">添加礼品</el-button>
            </div>

            <div v-if="!state.zxsData.gifts || !state.zxsData.gifts.length" class="empty-tip" style="margin-top: 10px">
              暂无礼品，点击上方按钮添加
            </div>

            <div v-for="(g, gi) in state.zxsData.gifts || []" :key="'gift-'+gi" class="gift-card">
              <div class="gift-row">
                <el-input
                  v-model="g.giftName"
                  placeholder="礼品名称（如：精美礼品A）"
                  style="width: 240px"
                />
                <el-input-number
                  v-model="g.perUserLimit"
                  :min="1"
                  :max="99"
                  style="width: 130px"
                />
                <span style="font-size: 12px; color: #909399; white-space: nowrap">每订单限领</span>
                <el-select
                  v-model="g.canGiveGysIds"
                  multiple
                  filterable
                  clearable
                  placeholder="可赠送的供应商（不选=所有供应商都不赠送）"
                  style="flex: 1; min-width: 280px"
                >
                  <el-option
                    v-for="item in state.gysData || []"
                    :key="item.Id"
                    :label="item.Mc"
                    :value="item.Id"
                  />
                </el-select>
                <el-button :icon="Delete" circle size="small" type="danger" @click="removeGift(gi)"/>
              </div>
              <div class="gift-tip">
                提示：同一礼品可被多个供应商赠送，但同一订单仅可领取 {{ g.perUserLimit }} 次（跨供应商互斥）
              </div>
            </div>
          </div>

          <!-- ===== 5. 购买须知 ===== -->
          <div class="zxs-block">
            <div class="zxs-block-header">
              <span class="zxs-block-title">📖 购买须知</span>
              <span class="zxs-block-tip">用户下单前需知悉的重要信息</span>
            </div>

            <div class="notice-section">
              <div class="notice-group">
                <div class="notice-group-title">
                  <el-icon><InfoFilled /></el-icon> 使用说明
                  <el-button size="small" text type="primary" @click="addNoticeItem('usage')">+ 添加</el-button>
                </div>
                <div v-for="(n, ni) in getNoticesByType('usage')" :key="'u'+ni" class="notice-edit-row">
                  <el-input v-model="n.content" placeholder="如：此产品为特殊房型，具体以实际安排为准..." />
                  <el-button :icon="Delete" circle size="small" @click="removeNoticeByIndex(ni, 'usage')" />
                </div>
                <div v-if="!getNoticesByType('usage').length" class="empty-tip-inline">暂无数据，点击添加</div>
              </div>

              <div class="notice-group">
                <div class="notice-group-title">
                  <el-icon><Warning /></el-icon> 退款规则
                  <el-button size="small" text type="primary" @click="addNoticeItem('refund')">+ 添加</el-button>
                </div>
                <div v-for="(n, ni) in getNoticesByType('refund')" :key="'r'+ni" class="notice-edit-row">
                  <el-input v-model="n.content" placeholder="如：未核销可全额退款..." />
                  <el-button :icon="Delete" circle size="small" @click="removeNoticeByIndex(ni, 'refund')" />
                </div>
                <div v-if="!getNoticesByType('refund').length" class="empty-tip-inline">暂无数据，点击添加</div>
              </div>

              <div class="notice-group">
                <div class="notice-group-title">
                  <el-icon><Document /></el-icon> 其他注意事项
                  <el-button size="small" text type="primary" @click="addNoticeItem('other')">+ 添加</el-button>
                </div>
                <div v-for="(n, ni) in getNoticesByType('other')" :key="'o'+ni" class="notice-edit-row">
                  <el-input v-model="n.content" placeholder="其他需要提醒用户的信息..." />
                  <el-button :icon="Delete" circle size="small" @click="removeNoticeByIndex(ni, 'other')" />
                </div>
                <div v-if="!getNoticesByType('other').length" class="empty-tip-inline">暂无数据，点击添加</div>
              </div>
            </div>
          </div>

        </el-tab-pane>

        <el-tab-pane lazy label="图片管理" name="tupian">
          <el-form-item style="width: 99%; display: flex; align-items: flex-start">
            <div style="display: flex; flex-wrap: wrap; gap: 10px">
              <div
                v-for="(tp, index) in state.imageData.Tps"
                :key="tp"
                :style="{
                  marginTop: '10px',
                  marginRight: '10px',
                  borderRadius: '5px',
                  overflow: 'hidden',
                  position: 'relative',
                  border: state.imageData.Fm === tp ? '3px solid #409eff' : '3px solid transparent',
                  boxSizing: 'border-box',
                }"
                class="uploadTpBox"
              >
                <img class="uploadTp" :src="getImageUrl(tp)" referrerpolicy="no-referrer" />
                <div style="text-align: center; padding: 8px; background: #f5f7fa">
                  <el-radio-group v-model="state.imageData.Fm" style="display: flex; justify-content: center">
                    <el-radio :label="tp" size="small">设为封面</el-radio>
                  </el-radio-group>
                </div>
                <div class="uploadDel">
                  <div class="uploadActions">
                    <el-icon size="28" class="actionIcon" @click="onPreviewTp(index)"><View /></el-icon>
                    <el-icon size="28" class="actionIcon" @click="onDelTp(index)"><Delete /></el-icon>
                  </div>
                </div>
              </div>
            </div>
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              :multiple="true"
              accept=".jpeg,.jpg,.png,.gif"
              :on-change="onUpload"
            >
              <template #trigger>
                <div class="uploadAdd">
                  <el-icon size="30" style="margin: auto; cursor: pointer"><Plus /></el-icon>
                </div>
              </template>
            </el-upload>
          </el-form-item>
          <!-- 图片预览 -->
          <el-image-viewer
            v-if="state.preview.show"
            :url-list="state.preview.urlList"
            :initial-index="state.preview.index"
            :teleported="false"
            @close="closePreview"
          />
        </el-tab-pane>

        <el-tab-pane lazy label="套餐管理" name="tc">
          <c_ZuHeChanPinTcList
            v-if="productId"
            :key="productId"
            :spId="productId"
          />
        </el-tab-pane>
        <el-tab-pane name="gz">
          <template #label>
            <text :style="{ color: state.tcData?.length > 0 ? '' : '#a2a2a2' }">
              销售控制
            </text>
          </template>
          <c_ZuHeChanPinGzList
            v-if="productId"
            :spId="productId"
            :key="state.gzKey"
          />
        </el-tab-pane>

        <!-- 评价信息 -->
        <el-tab-pane lazy label="评价信息" name="pingjia">
          <div class="pjWrap">
            <!-- 评价统计概览 -->
            <div class="pjSummary" v-if="state.pjSummary.totalCount > 0">
              <div class="pjScoreBox">
                <span class="pjScore">{{ state.pjSummary.avgRating }}</span>
                <span class="pjUnit">/5</span>
                <div class="pjStars">
                  <el-rate
                    v-model="state.pjSummary.avgRating"
                    disabled
                    show-score
                    text-color="#ff9900"
                  />
                </div>
                <span class="pjTotal"
                  >共 {{ state.pjSummary.totalCount }} 条评价</span
                >
              </div>
              <div class="pjDist">
                <div class="pjDistItem" v-for="i in 5" :key="i">
                  <span class="pjDistLabel">{{ 6 - i }}星</span>
                  <el-progress
                    :percentage="getRatingPercent(6 - i)"
                    :show-text="false"
                    :stroke-width="8"
                    color="#f5a623"
                  />
                  <span class="pjDistCount">{{ getRatingCount(6 - i) }}</span>
                </div>
              </div>
            </div>

            <!-- 评价列表 -->
            <div class="pjList">
              <div class="pjItem" v-for="pj in pagedPjList" :key="pj.Id">
                <div class="pjHeader">
                  <span class="pjUser">{{ pj.CjrXm }}</span>
                  <el-rate v-model="pj.Xj" disabled size="small" />
                  <span class="pjTime">{{ formatTime(pj.Cjsj) }}</span>
                </div>
                <div class="pjTags" v-if="pj.PjBq">
                  <el-tag
                    v-for="tag in pj.PjBq.split(',')"
                    :key="tag"
                    size="small"
                    type="info"
                    style="margin-right: 6px"
                    >{{ tag }}</el-tag
                  >
                </div>
                <div class="pjContent">{{ pj.PjNr }}</div>
                <div class="pjImages" v-if="pj.PjTp">
                  <el-image
                    v-for="(img, idx) in pj.PjTp.split(',')"
                    :key="idx"
                    :src="$http.defaults.baseURL + img"
                    :preview-src-list="
                      pj.PjTp.split(',').map((u) => $http.defaults.baseURL + u)
                    "
                    :initial-index="idx"
                    fit="cover"
                    class="pjImg"
                  />
                </div>
                <!-- 商家回复 -->
                <div class="pjReply" v-if="pj.HfNr">
                  <div class="pjReplyHeader">
                    <span class="pjReplyLabel">商家回复</span>
                    <span class="pjReplyTime">{{ formatTime(pj.HfSj) }}</span>
                  </div>
                  <div class="pjReplyContent">{{ pj.HfNr }}</div>
                </div>
              </div>

              <!-- 分页 -->
              <div
                class="pjPagination"
                v-if="state.pjList.length > state.pjPageSize"
              >
                <el-pagination
                  v-model:current-page="state.pjPageIndex"
                  :page-size="state.pjPageSize"
                  :total="state.pjList.length"
                  layout="total, prev, pager, next"
                  background
                  small
                />
              </div>

              <!-- 暂无评价 -->
              <div
                class="pjEmpty"
                v-if="state.pjLoaded && state.pjList.length === 0"
              >
                <el-empty description="暂无评价信息" />
              </div>
            </div>
          </div>
        </el-tab-pane>

      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive, ref, computed } from "vue";
import draggable from "vuedraggable";
import { Delete, Plus, Edit, Check, InfoFilled, Warning, Document, View } from "@element-plus/icons-vue";
import {
  zuhechanpin_edit,
  zuhechanpin_detail,
  zuhechanpin_tc_list,
  shangpin_uploadtp,
  gongyingshang_select,
  home_uploadconfig,
  shangpinpingjia_getbyspid,
  shangpinpingjia_getsummary,
} from "@/http/api";
import $http from "@/http/index";
import { ElMessage } from "element-plus";

export default {
  components: { draggable },
  props: {
    data: Object,
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const tagInputRef = ref(null);
    const editorVersion = ref(0); // 用于强制重建富文本编辑器

    const productId = computed(() => props.data?.id);

    // 分页后的评价列表
    const pagedPjList = computed(() => {
      const start = (state.pjPageIndex - 1) * state.pjPageSize;
      return state.pjList.slice(start, start + state.pjPageSize);
    });

    const state = reactive({
      saving: false,
      activeTab: "zxs",
      // 基础信息
      model: {
        IsQy: true,
        Mc: "",
        Jj: "",
        YxKssj: "",
        YxJzsj: "",
        GysId: null,
        Yhj: 0,
        DdyxLx: 0,
        YxqKs: "",
        YxqJs: "",
        YxqMonths: 1,
        HeXiaoMaLeiXing: 0,
        SupplierGoodsId: "",
      },
      gysData: [],
      imageBaseUrl: "",
      // 图片管理
      imageData: {
        Tps: [],
        Fm: "",
      },
      // 图片预览
      preview: {
        show: false,
        urlList: [],
        index: 0,
      },
      // 住享食详情
      zxsData: {
        displayTitle: '',
        subtitle: '',
        featureTags: [],
        originalPrice: 0,
        currentPrice: 0,
        priceNote: '',
        packages: [],
        gifts: [],
        notices: [],
        refundPolicy: "",
        tips: "",
      },
      tagInputVisible: false,
      tagInputValue: "",
      // 套餐/销售控制
      tcData: [],
      gzKey: 0,
      // 评价信息
      pjList: [],
      pjLoaded: false,
      pjPageIndex: 1,
      pjPageSize: 5,
      pjSummary: {
        totalCount: 0,
        avgRating: 0,
        ratingDistribution: {},
      },
    });

    // ==================== 数据加载 ====================

    function createEmptyPackage() {
      return {
        name: "",
        price: 0,
        bedType: "",
        guests: "2",
        area: "",
        floor: "",
        category: "住",      // 类别：食/享/住，默认"住"
        phone: "",          // 联系电话
        ruleDesc: "",       // 规则说明
        receptionTime: "",  // 接待时间
        contents: [{ text: "" }],
        usageRule: "",
        images: [],
        gysId: null,       // 关联供应商ID
        tcSpId: 0,         // 套餐产品ID（固定为0）
        nights: 1,         // 住宿晚数（仅类别=住时显示）
        jsj: 0,            // 结算价（与本项对应的供应商结算时的单价）
        _expanded: true,
      };
    }

    onMounted(() => {
      loadUploadConfig();
      loadGys();
      if (productId.value) {
        loadDetail();
        onLoadTc();
      }
    });

    // 加载套餐数据（用于判断销售控制 tab 是否可进入）
    const onLoadTc = () => {
      if (!productId.value) return;
      zuhechanpin_tc_list(productId.value).then((res) => {
        if (res.status == 200) {
          state.tcData = res.data;
        }
      });
    };

    // 选项卡切换
    const onTabsChange = (value) => {
      if (value === "gz") {
        // 切换前重新加载套餐数据，确保判断准确
        return zuhechanpin_tc_list(productId.value).then((res) => {
          if (res.status == 200) {
            state.tcData = res.data;
          }
          if (state.tcData?.length <= 0) {
            ElMessage({
              type: "warning",
              message: "请先在「套餐管理」中添加套餐！",
              grouping: true,
            });
            return false;
          }
          state.gzKey = Math.random();
        });
      } else if (value === "pingjia") {
        state.pjPageIndex = 1;
        loadPingJia();
      }
    };

    const loadDetail = () => {
      zuhechanpin_detail(productId.value).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          state.model = {
            IsQy: data.IsQy,
            Mc: data.Mc || "",
            Jj: data.Jj || "",
            YxKssj: data.YxKssj || "",
            YxJzsj: data.YxJzsj || "",
            GysId: data.GysId || null,
            Yhj: data.Yhj || 0,
            IsYuyue: data.IsYuyue || false,
            YuyueTianShu: data.YuyueTianShu || null,
            DdyxLx: data.DdyxLx ?? 0,
            YxqKs: data.YxqKs || "",
            YxqJs: data.YxqJs || "",
            YxqMonths: data.DdyxLx === 1 ? calcMonthsBetween(data.YxqKs, data.YxqJs) : 1,
            HeXiaoMaLeiXing: data.HeXiaoMaLeiXing ?? 0,
            SupplierGoodsId: data.SupplierGoodsId || "",
          };

          // 宽表字段直接读取，不再从 KuoZhans 数组中解析
          // 住享食详情
          if (data.ZxsData) {
            try {
              const parsed = JSON.parse(data.ZxsData);
              state.zxsData = {
                displayTitle: parsed.displayTitle || '',
                subtitle: parsed.subtitle || '',
                featureTags: Array.isArray(parsed.featureTags) ? parsed.featureTags : [],
                originalPrice: parsed.originalPrice || 0,
                currentPrice: parsed.currentPrice || 0,
                priceNote: parsed.priceNote || '',
                packages: Array.isArray(parsed.packages) && parsed.packages.length > 0
                  ? parsed.packages.map(p => ({ ...p, _expanded: true, nights: p.nights || 1, category: p.category || "住" })) : [],
                gifts: Array.isArray(parsed.gifts) ? parsed.gifts.map(g => ({
                  giftId: g.giftId || crypto.randomUUID(),
                  giftName: g.giftName || '',
                  perUserLimit: g.perUserLimit || 1,
                  canGiveGysIds: Array.isArray(g.canGiveGysIds) ? g.canGiveGysIds : []
                })) : [],
                notices: Array.isArray(parsed.notices) ? parsed.notices : [],
                refundPolicy: parsed.refundPolicy || "",
                tips: parsed.tips || "",
              };
              state.imageData.Tps = parsed.Tps || [];
              state.imageData.Fm = parsed.Fm || (parsed.Tps?.[0] || "");
            } catch (e) {
              console.warn("住享食扩展数据解析失败", e);
            }
          }

          // 数据加载完成后，重建富文本编辑器以显示图片
          editorVersion.value++;
        }
      });
    };

    const loadGys = () => {
      gongyingshang_select().then((res) => {
        if (res.status == 200) state.gysData = res.data;
      });
    };
    // 根据开始日期和结束日期反推月份数（顺延有效期回显用）
    const calcMonthsBetween = (start, end) => {
      if (!start || !end) return 1;
      const s = new Date(start);
      const e = new Date(end);
      if (isNaN(s.getTime()) || isNaN(e.getTime())) return 1;
      const months = (e.getFullYear() - s.getFullYear()) * 12 + (e.getMonth() - s.getMonth());
      return months > 0 ? months : 1;
    };

    // 日期格式化为 ISO 8601 字符串（适配 .NET System.Text.Json 的 DateTime 反序列化）
    const pad = (n) => String(n).padStart(2, '0');
    const formatIsoDate = (d) => {
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    };

    // 当前日期加 N 个月
    const addMonths = (d, n) => {
      const dt = new Date(d.getTime());
      dt.setMonth(dt.getMonth() + n);
      return dt;
    };


    // ==================== 图片管理 ====================

    const loadUploadConfig = () => {
      home_uploadconfig().then((res) => {
        if (res.status == 200) {
          const config = res.data;
          if (config.useOss && config.ossBaseUrl) {
            state.imageBaseUrl = config.ossBaseUrl;
          } else {
            state.imageBaseUrl = $http.defaults.baseURL;
          }
        }
      }).catch(() => {
        state.imageBaseUrl = $http.defaults.baseURL;
      });
    };

    const getImageUrl = (tp) => {
      if (!tp) return "";
      const url = String(tp).trim();
      if (url.startsWith("http://") || url.startsWith("https://")) return url;
      if (state.imageBaseUrl) return state.imageBaseUrl + url;
      return $http.defaults.baseURL + url;
    };

    const onUpload = (file) => {
      let formData = new FormData();
      formData.append("files", file.raw);
      shangpin_uploadtp(formData).then((res) => {
        if (res.status == 200) {
          state.imageData.Tps = [...state.imageData.Tps, ...res.data];
          if (!state.imageData.Fm) {
            state.imageData.Fm = state.imageData.Tps[0];
          }
        }
      });
    };

    const onDelTp = (index) => {
      state.imageData.Tps.splice(index, 1);
      if (state.imageData.Fm && !state.imageData.Tps.includes(state.imageData.Fm)) {
        state.imageData.Fm = state.imageData.Tps.length > 0 ? state.imageData.Tps[0] : "";
      }
    };

    const onPreviewTp = (index) => {
      state.preview.urlList = state.imageData.Tps.map((tp) => getImageUrl(tp));
      state.preview.index = index;
      state.preview.show = true;
    };

    const closePreview = () => {
      state.preview.show = false;
    };

    // ==================== 住享食详情操作 ====================

    const addPackage = () => {
      state.zxsData.packages.push(createEmptyPackage());
    };

    const removePackage = (index) => {
      state.zxsData.packages.splice(index, 1);
    };

    // ==================== 礼品配置操作 ====================

    const addGift = () => {
      if (!state.zxsData.gifts) state.zxsData.gifts = [];
      state.zxsData.gifts.push({
        giftId: crypto.randomUUID(),
        giftName: '',
        perUserLimit: 1,
        canGiveGysIds: []
      });
    };

    const removeGift = (index) => {
      state.zxsData.gifts.splice(index, 1);
    };

    const addNoticeItem = (type) => {
      state.zxsData.notices.push({ type, content: '' });
    };

    const removeNoticeByIndex = (idx, type) => {
      const arr = getNoticesByType(type);
      const realItem = arr[idx];
      const realIdx = state.zxsData.notices.indexOf(realItem);
      if (realIdx >= 0) state.zxsData.notices.splice(realIdx, 1);
    };

    const togglePkgExpand = (index) => {
      state.zxsData.packages[index]._expanded = !state.zxsData.packages[index]._expanded;
    };

    // 购买须知按类型分组
    const getNoticesByType = (type) => {
      return (state.zxsData.notices || []).filter(n => n.type === type);
    };

    // ==================== 评价信息 ====================

    const loadPingJia = () => {
      if (!productId.value) return;
      shangpinpingjia_getbyspid(productId.value).then((res) => {
        if (res.status == 200) {
          state.pjList = res.data || [];
          state.pjLoaded = true;
        }
      });
      shangpinpingjia_getsummary(productId.value).then((res) => {
        if (res.status == 200) {
          state.pjSummary = res.data;
        }
      });
    };

    const getRatingPercent = (star) => {
      const dist = state.pjSummary?.ratingDistribution;
      const total = state.pjSummary?.totalCount;
      if (!dist || !total) return 0;
      const map = {
        1: dist?.one,
        2: dist?.two,
        3: dist?.three,
        4: dist?.four,
        5: dist?.five,
      };
      const count = map[star] || 0;
      return Math.round((count / total) * 100);
    };

    const getRatingCount = (star) => {
      const dist = state.pjSummary?.ratingDistribution;
      const map = {
        1: dist?.one,
        2: dist?.two,
        3: dist?.three,
        4: dist?.four,
        5: dist?.five,
      };
      return map[star] || 0;
    };

    const formatTime = (val) => {
      if (!val) return '';
      const str = String(val);
      return str.replace('T', ' ').replace(/\.\d+$/, '');
    };

    // ==================== 提交 ====================

    const onSaveBase = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        state.saving = true;

        const payload = {
          IsQy: state.model.IsQy,
          Mc: state.model.Mc,
          Jj: state.model.Jj,
          Fm: state.imageData.Fm || null,
          Tp: state.imageData.Tps.join(","),
          YxKssj: state.model.YxKssj || null,
          YxJzsj: state.model.YxJzsj || null,
          GysId: state.model.GysId,
          Yhj: state.model.Yhj,
          IsYuyue: state.model.IsYuyue || false,
          YuyueTianShu: state.model.YuyueTianShu || null,
          HeXiaoMaLeiXing: state.model.HeXiaoMaLeiXing ?? 0,
          SupplierGoodsId: state.model.SupplierGoodsId || "",
          DdyxLx: state.model.DdyxLx ?? 0,
          YxqKs: state.model.DdyxLx === 0
            ? (state.model.YxqKs || null)
            : (state.model.DdyxLx === 1 ? formatIsoDate(new Date()) : null),
          YxqJs: state.model.DdyxLx === 0
            ? (state.model.YxqJs || null)
            : (state.model.DdyxLx === 1
                ? formatIsoDate(addMonths(new Date(), state.model.YxqMonths || 1))
                : null),
          ZxsData: JSON.stringify({
            ...state.zxsData,
            Tps: state.imageData.Tps,
            Fm: state.imageData.Fm,
          }),
        };

        zuhechanpin_edit(productId.value, payload)
          .then((res) => {
            if (res.status == 200) {
              proxy.$message.success("保存成功");
              loadDetail();
            }
          })
          .finally(() => {
            state.saving = false;
          });
      });
    };

    return {
      state,
      formDom,
      tagInputRef,
      productId,
      editorVersion,
      // 图片管理
      getImageUrl,
      onUpload,
      onDelTp,
      onPreviewTp,
      closePreview,
      // 住享食详情
      addPackage,
      removePackage,
      togglePkgExpand,
      // 礼品配置
      addGift,
      removeGift,
      getNoticesByType,
      addNoticeItem,
      removeNoticeByIndex,
      createEmptyPackage,
      // 套餐/销售控制
      onTabsChange,
      onLoadTc,
      // 评价信息
      pagedPjList,
      loadPingJia,
      getRatingPercent,
      getRatingCount,
      formatTime,
      // 提交
      onSaveBase,
      // icons
      Delete,
      Plus,
      Edit,
      Check,
      InfoFilled,
      Warning,
      Document,
      View,
    };
  },
};
</script>

<style scoped lang="less">
.detailBox {
  height: 100%;
  overflow-y: auto;
}

/* ========== 基础信息区域 ========== */
.baseInfoSection {
  background: #fff;
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.baseInfoHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 14px;
}

.sectionTitle {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.baseInfoForm {
  margin-bottom: 0;
}

.formGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 0 16px;
}

.formGrid :deep(.el-form-item) {
  flex: 0 0 calc(33.333% - 11px);
  margin-right: 0;
  margin-bottom: 14px;
}

.formGrid :deep(.el-form-item .el-select),
.formGrid :deep(.el-form-item .el-input),
.formGrid :deep(.el-form-item .el-input-number) {
  width: 100%;
}

.formGrid :deep(.formItemGroup) {
  flex: 0 0 calc(33.333% - 11px);
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
}

.formGrid :deep(.formItemGroup .el-form-item) {
  flex: 0 0 auto;
  margin-bottom: 0;
}

.formGrid :deep(.formItemGroup .formItemYuyueTianShu) {
  flex: 1;
}

.formItemFull {
  flex: 0 0 100% !important;
}

/* ========== Tab 区域 ========== */
.tabSection {
  background: #fff;
  border-radius: 8px;
  padding: 0 24px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}


/* ========== 住享食详情区块样式 ========== */
.zxs-block {
  margin-bottom: 20px;
  padding: 16px 18px;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  background: #fafbfc;
}

.zxs-block-header {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.zxs-block-title {
  font-size: 15px;
  font-weight: 700;
  color: #303133;
  margin-right: 12px;
}

.zxs-block-tip {
  font-size: 12px;
  color: #999;
}

/* ========== 套餐卡片 V2（橙色标题栏） ========== */
.package-list {
  width: 100%;
}

.package-card-v2 {
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  margin-bottom: 14px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
}

.pkgv2-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #F5F5F5;
}

.pkgv2-label {
  font-size: 13px;
  font-weight: 700;
  color: #e6a23c;
  white-space: nowrap;
}

.tabSection :deep(.el-tabs__header) {
  margin-bottom: 0;
}

.pkgv2-body {
  padding: 14px 16px;
  border-top: 1px solid #f2f2f2;
}

.pkgv2-section {
  margin-bottom: 14px;
  > label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 8px;
  }
  &:last-child { margin-bottom: 0; }
}

/* ========== 购买须知分组 ========== */
.notice-section {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.notice-group {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px 14px;
  background: #fff;
}

.notice-group-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f2f2f2;

  .el-button { margin-left: auto; }
}

.notice-edit-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;

  .el-input { flex: 1; }
}

/* ========== 图片管理通用样式 ========== */
.uploadAdd {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  border-radius: 5px;
  border: 1px dashed #e2e2e2;
  display: flex;
  color: #a2a2a2;
}
.uploadAdd:hover {
  background-color: rgba(100, 100, 100, 0.2) !important;
  color: #fff !important;
}
.uploadDel {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  color: #fff;
  display: none;
}
.uploadActions {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 12px;
  box-sizing: border-box;
}
.actionIcon {
  cursor: pointer;
  transition: transform 0.2s;
}
.actionIcon:hover {
  transform: scale(1.15);
}
.uploadTp {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}
.uploadTpBox:hover .uploadDel {
  display: flex !important;
}

.empty-tip-inline {
  font-size: 13px;
  color: #bbb;
}

/* ===== 礼品配置 ===== */
.gift-card {
  background: #fffbf6;
  border: 1px dashed #f0c98e;
  border-radius: 8px;
  padding: 14px 16px;
  margin-top: 10px;
}

.gift-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.gift-tip {
  font-size: 12px;
  color: #b88230;
  margin-top: 8px;
  padding-left: 2px;
}

.sp-loadmore-option {
  text-align: center;
  color: #409eff !important;
  cursor: pointer;
}

/* ===== 评价信息 ===== */
.pjWrap {
  padding: 10px 0;
}

.pjSummary {
  display: flex;
  gap: 40px;
  padding: 20px 24px;
  background: #fafbfc;
  border-radius: 8px;
  margin-bottom: 20px;
  align-items: center;
}

.pjScoreBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 140px;
}

.pjScore {
  font-size: 42px;
  font-weight: 700;
  color: #ff9900;
  line-height: 1;
}

.pjUnit {
  font-size: 18px;
  color: #999;
  margin-bottom: 6px;
}

.pjStars {
  margin: 4px 0;
}

.pjTotal {
  font-size: 13px;
  color: #999;
  margin-top: 4px;
}

.pjDist {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pjDistItem {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pjDistLabel {
  font-size: 13px;
  color: #666;
  width: 30px;
  text-align: right;
}

.pjDistCount {
  font-size: 13px;
  color: #999;
  width: 28px;
}

.pjList {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pjItem {
  padding: 16px 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.pjHeader {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.pjUser {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.pjTime {
  font-size: 12px;
  color: #bbb;
  margin-left: auto;
}

.pjTags {
  margin-bottom: 8px;
}

.pjContent {
  font-size: 14px;
  color: #555;
  line-height: 1.7;
  margin-bottom: 10px;
  white-space: pre-wrap;
  word-break: break-word;
}

.pjImages {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.pjImg {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ebeef5;
}

.pjReply {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 10px 14px;
  margin-top: 8px;
}

.pjReplyHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.pjReplyLabel {
  font-size: 12px;
  font-weight: 600;
  color: #409eff;
}

.pjReplyTime {
  font-size: 12px;
  color: #bbb;
}

.pjReplyContent {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

.pjPagination {
  display: flex;
  justify-content: center;
  padding: 12px 0;
}

.pjEmpty {
  padding: 40px 0;
}

</style>
